import { useState } from "react"
import { Button, message, Modal, Select } from "antd"
import { swimminglyApi, gen } from "./utils"
import { updateSeasonMeetArrayListener } from "./MeetSchedulePageNew"
import { IClubSeasonInformation } from "./MeetActionsModal"

const { Option } = Select

interface IVirtualMeetCourseModalProps {
  virtualMeetId: number | null
  visible: boolean
  setVisible: (newVisible: boolean) => void
  clubSeason: IClubSeasonInformation | null
  currentCourse: "SCY" | "SCM" | "LCM" | null
  refresh: () => void
}

const courseToNumericValue = (course: "SCY" | "SCM" | "LCM" | null) => {
  if (course === "SCY") return 0
  if (course === "SCM") return 1
  if (course === "LCM") return 2
  return null
}

export default function VirtualMeetCourseModal({
  virtualMeetId,
  visible,
  setVisible,
  clubSeason,
  currentCourse,
  refresh,
}: IVirtualMeetCourseModalProps): JSX.Element {
  const [newCourse, setNewCourse] = useState<number | null>(null)
  const [loading, setLoading] = useState(false)
  const currentCourseValue = courseToNumericValue(currentCourse)
  const isOkDisabled = newCourse === null || newCourse === currentCourseValue

  const closeModal = () => {
    setVisible(false)
    setNewCourse(null)
  }

  const onOk = () => {
    if (isOkDisabled) {
      return
    }

    setLoading(true)
    swimminglyApi
      .post(gen("/api/updateVirtualMeetCourse"))
      .body({ virtualMeetId, newCourse })
      .then((data) => {
        if (!data || data.status === "error") {
          console.error(data || "outcome not found")
          message.error("Uh oh, something went wrong...")
        } else {
          message.success(
            "You've successfully updated the course of your virtual meet!",
          )
          closeModal()
          refresh()
          if (clubSeason) {
            updateSeasonMeetArrayListener.emit(
              `updateSeasonMeets${clubSeason.clubSeasonId}`,
            )
          }
        }
      })
      .finally(() => setLoading(false))
  }

  const onCancel = () => {
    closeModal()
  }

  return (
    <Modal
      title="Update Virtual Meet Course"
      open={visible}
      footer={[
        <Button key="back" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={onOk}
          disabled={isOkDisabled}
        >
          Ok
        </Button>,
      ]}
    >
      <div>
        <p>Choose below to update the course of your virtual meet</p>
        <p>
          NOTE: this will update the Virtual Meet course for all participants.
        </p>
        <p>
          Current Virtual Meet Course: <strong>{currentCourse || "Unknown"}</strong>
        </p>
        <Select
          style={{ minWidth: "180px" }}
          value={newCourse ?? currentCourseValue ?? -1}
          onChange={(value) => setNewCourse(value === -1 ? null : value)}
        >
          <Option value={-1} disabled>
            Choose course...
          </Option>
          <Option value={0}>SCY</Option>
          <Option value={1}>SCM</Option>
          <Option value={2}>LCM</Option>
        </Select>
      </div>
    </Modal>
  )
}
